import { withProcedureWraper } from "../../../..";
import { Icon } from "../../../../../../components";
import { useHistory } from "react-router-dom";
import { PATH } from "../../constant/path";
import { Progress } from "../../components/progress";
import { Information } from "../../components/information";
import { History } from "../../components/history";
import { Form, Skeleton, Modal, Input } from "antd";
import { StyledButton } from "../../../../../../components/styled-antd";
import {
  isEnableAccept,
  isEnableRevoke,
  isEnableEdit,
  getNextStep,
  getRevokeStep,
} from "../../../../human-organization/summary-employee-request/utils/step";
import { useGetDetailRequests } from "../../hooks/get-detail-request";
import { useSelector } from "../../../../../../store/store";
import { CreateNotification } from "../../../../../../components/notifier";
import { requestStatus } from "../../../../../../constants";
import { useRouteMatch } from "react-router-dom";
import { getUCTDate } from "../../../../../../helper/dateTimeHelper";
import { sendEmail } from "../../../../human-organization/summary-employee-request/utils/send-mail";
import { MAIL_TEMPLATE } from "../../constant/mail-template";
import { getEnv } from "../../../../../../AppConfigs";
import { useEmployee, useSoftwares } from "../../../../../../hook";
import { SystemCode } from "../../../../../../constants";
import { StyledTitle } from "../../../../../../components/styled-antd";
import { StationeryRequestService } from "../../../../../../services/company-office/StationeryRequest.service";
import { getApprover } from "../../../../human-organization/summary-employee-request/utils/get-employee-detail";

const siteUrl = getEnv("REACT_APP_STATIONARY_REQUEST");

export const Detail = withProcedureWraper(() => {
  const history = useHistory();
  const [form] = Form.useForm();

  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username?.toString().toLowerCase();
  const { id } = useRouteMatch().params as any;

  const mailtemplates = useSelector(
    (state: any) => state.systemMgmt.mailtemplates
  );

  const { getITLeadITHeadAssignee } = useSoftwares();
  const { data: employees } = useEmployee();
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);

  const { data, isLoading } = useGetDetailRequests();

  if (isLoading) return <Skeleton />;

  const approveRequest = async () => {
    const nextStep = getNextStep(data);

    try {
      if (nextStep === 1) {
        await StationeryRequestService.updateStationeryRequest(
          id,
          {
            eApprovedStatus: requestStatus.approved,
            eApprovedDate: getUCTDate(),
            eRequestStatus: requestStatus.approved,
            eApprovalComments: form.getFieldValue("comment") || "",
          }
        );

        sendEmail(
          data,
          MAIL_TEMPLATE.APPROVE,
          getApprover(
            data?.fields?.eApprovedByITLead,
            employees,
            softwares,
            getITLeadITHeadAssignee(SystemCode.SR).eAssignee
          ),
          mailtemplates,
          "",
          siteUrl
        );
      } else if (nextStep === 2) {
        await StationeryRequestService.updateStationeryRequest(
          id,
          {
            eApprovedByITLeadStatus: requestStatus.approved,
            eApprovedByITLeadDate: getUCTDate(),
            eITLeadComment: form.getFieldValue("comment") || "",
            eRequestStatus: requestStatus.completed,
          }
        );

        sendEmail(
          data,
          MAIL_TEMPLATE.FINISH,
          "",
          mailtemplates,
          "",
          siteUrl,
          form.getFieldValue("comment") || ""
        );
      }

      CreateNotification({
        title: "Thành công",
        body: `Đồng ý thành công.`,
        icon: "/icons/success.png",
      });
      history.push(PATH.HOME);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Duyệt thất bại`,
        icon: "/icons/error.png",
      });
      history.push(PATH.HOME);
    }
  };

  const rejectRequest = async () => {
    if (!form.getFieldValue("comment")) {
      CreateNotification({
        title: "Thất bại",
        body: `Vui lòng nhập lý do từ chối`,
        icon: "/icons/error.png",
      });

      return;
    }

    const nextStep = getNextStep(data);

    try {
      if (nextStep === 1) {
         await StationeryRequestService.updateStationeryRequest(id, {
          eRequestStatus: requestStatus.rejected,
          eApprovedStatus: requestStatus.rejected,
          eApprovedDate: getUCTDate(),
          eApprovalComments: form.getFieldValue("comment") || "",
        });
      } else if (nextStep === 2) {
        await StationeryRequestService.updateStationeryRequest(id, {
          eRequestStatus: requestStatus.rejected,
          eApprovedByITLeadStatus: requestStatus.rejected,
          eApprovedByITLeadDate: getUCTDate(),
          eITLeadComment: form.getFieldValue("comment") || "",
        });
      }

      sendEmail(data, MAIL_TEMPLATE.REJECT, "", mailtemplates, "", siteUrl);

      CreateNotification({
        title: "Thành công",
        body: `Từ chối thành công.`,
        icon: "/icons/success.png",
      });

      history.push(PATH.HOME);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Từ chối thất bại`,
        icon: "/icons/error.png",
      });
      history.push(PATH.HOME);
    }
  };

  const revokeApproval = async () => {
    const currentStep = getRevokeStep(data, currentUserName);

    try {
      if (currentStep === 1) {
        await StationeryRequestService.updateStationeryRequest(
          id,
          {
            eRequestStatus: requestStatus.submitted,
            eApprovedStatus: requestStatus.submitted,
            eApprovedDate: getUCTDate(),
          }
        );
      } else if (currentStep === 2) {
        await StationeryRequestService.updateStationeryRequest(
          id,
          {
            eRequestStatus: requestStatus.submitted,
            eApprovedByITLeadStatus: requestStatus.submitted,
            eApprovedByITLeadDate: getUCTDate(),
            eITLeadComment: form.getFieldValue("comment") || "",
          }
        );
      }

      CreateNotification({
        title: "Thành công",
        body: `Thu hồi thành công.`,
        icon: "/icons/success.png",
      });

      history.push(PATH.HOME);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Thu hồi thất bại`,
        icon: "/icons/error.png",
      });

      history.push(PATH.HOME);
    }
  };

  const showRejectConfirm = () => {
    Modal.confirm({
      title: <StyledTitle level={5}>Thông báo</StyledTitle>,
      content: (
        <>
          Bạn có chắc chắn muốn từ chối yêu cầu này ?
          <br />
          Vui lòng nhập lý do từ chối
          <br />
          <StyledTitle level={5}>
            Lý do <span className="text-danger ml-1">*</span>{" "}
          </StyledTitle>
          <Input
            onChange={(e: any) => {
              form.setFieldValue("comment", e.target.value);
            }}
          />
        </>
      ),
      okText: "Xác nhận",
      okType: "danger",
      okButtonProps: { type: "primary" },
      cancelText: "Huỷ",
      cancelButtonProps: {
        style: { backgroundColor: "orange", color: "white" },
      },

      onOk() {
        rejectRequest();
      },
      onCancel() {
        form.setFieldValue("comment", null);
      },
    });
  };

  return (
    <div className="ItCodeGrantedDetailPage pd15">
      <div className="PageHead">
        <div className="title">
          <div className="btnBack" onClick={() => history.push(PATH.HOME)}>
            <Icon.ArrowLeft />
          </div>
          Xem Xét Yêu Cầu Duyệt
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 col-md-12">
          <Progress />
          <Information />
          <History form={form} />
        </div>
      </div>

      <div className="d-flex justify-content-center">
        {isEnableAccept(data, currentUserName) && (
          <StyledButton
            bgColor="green"
            className="mr-3"
            type="primary"
            onClick={approveRequest}
          >
            Đồng ý
          </StyledButton>
        )}

        {isEnableAccept(data, currentUserName) && (
          <StyledButton
            bgColor="grey"
            className="mr-3"
            type="primary"
            onClick={showRejectConfirm}
          >
            Không đồng ý
          </StyledButton>
        )}

        {!isEnableAccept(data, currentUserName) &&
          isEnableRevoke(data, currentUserName) && (
            <StyledButton
              bgColor="grey"
              className="mr-3"
              onClick={revokeApproval}
            >
              Thu hồi
            </StyledButton>
          )}

        {isEnableEdit(data, currentUserName) && (
          <StyledButton
            bgColor="orange"
            onClick={() => {
              history.push(PATH.EDIT.replace(":id", id));
            }}
          >
            Chỉnh sửa
          </StyledButton>
        )}
      </div>
    </div>
  );
});
